
import { useEffect } from 'react';
import { UseFormReturn } from 'react-hook-form';
import ClassifierValueType from '../../../../enums/classifier-value-type';
import { useWarehouseContext } from './warehouse-context';

export default function useFormTrigger(
  formMethods: UseFormReturn,
) {
  const products = formMethods.getValues('products');

  const {
    isTargetUsageRequired,
    setIsTargetUsageRequired,
    isPartnerRequired,
    setIsPartnerRequired,
  } = useWarehouseContext()

  useEffect(() => {
    if (products !== undefined) {
      let targetUsageRequiredCount = 0;
      let partnerRequiredCount = 0;

      products.forEach((product) => {
        if (product.product_category_id.type === ClassifierValueType.BIOCIDES) {
          targetUsageRequiredCount++;
        }

        if (product.product_category_id.type === ClassifierValueType.PLANT_PROTECTION_PRODUCTS) {
          partnerRequiredCount++;
        }
      })

      setIsTargetUsageRequired(!!targetUsageRequiredCount);
      setIsPartnerRequired(!!partnerRequiredCount);
    }
  }, [products, setIsTargetUsageRequired, setIsPartnerRequired])

  useEffect(() => {
    formMethods.trigger();
  }, [formMethods, isTargetUsageRequired, isPartnerRequired]);
}
